/**
 * Application Route Constants
 *
 * Public routes. Admin routes (cucs-advising) are in @metlas/cucs-advising.
 */

export const PUBLIC_ROUTES = {
  HOME: '/',
  /** Old address of the home page; redirects to HOME. */
  LANDING_PAGE: '/landing_page',
  CAREERS: '/careers',
  CONTACT: '/contact',
  CUCS_ADVISING: '/apps/cucs-advising',
  CU_MARKETPLACE: '/cu-marketplace',
  PROPERTY_MANAGEMENT: '/property-management',
  PROPERTY_MANAGEMENT_SAMPLE_REPORT: '/property-management/sample-competitor-analysis-report',
  PROPERTY_MANAGEMENT_APP: '/property-management/app',
  PROPERTY_MANAGEMENT_LEAD_ACQUISITION: '/property-management/lead-acquisition',
  PROPERTY_MANAGEMENT_COMPETITOR_ANALYSIS: '/property-management/competitor-analysis',
  RE_INVESTOR: '/RE-investor',
  RE_INVESTOR_LP_PROSPECTING: '/RE-investor/lp-prospecting',
  RE_INVESTOR_UNDERWRITING: '/RE-investor/underwriting',
  REALTOR: '/realtor',
  GMAIL_EXTRACTOR: '/gmail-extractor',
  GMAIL_EXTRACTOR_CALLBACK: '/auth/callback',
  PRIVACY_TERMS: '/privacy-terms',
  CASE_STUDY_ACCOUNTING: '/case-studies/accounting',
  TRUSTWORTHY_AGENT: '/trustworthy-agent',
  BUILDING_INTELLIGENCE: '/building-intelligence',
  EXPEDITER_BUILDING_INTELLIGENCE: '/expediter/building-intelligence',
  COMPETITOR_ANALYSIS: '/apps/competitor-analysis',
} as const;
